import { AlertTriangle } from 'lucide-react'
import Modal from './Modal'

interface ConfirmDialogProps {
  isOpen: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  isBusy?: boolean
  onConfirm: () => void | Promise<void>
  onCancel: () => void
}

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  isBusy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => (
  <Modal
    isOpen={isOpen}
    onClose={isBusy ? () => undefined : onCancel}
    title={title}
    eyebrow="Confirmation requise"
    size="sm"
    footer={(
      <>
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={isBusy}>{cancelLabel}</button>
        <button type="button" className="btn-danger" onClick={() => void onConfirm()} disabled={isBusy}>
          {isBusy ? 'Traitement…' : confirmLabel}
        </button>
      </>
    )}
  >
    <div className="confirm-dialog-copy">
      <span className="confirm-dialog-icon" aria-hidden="true"><AlertTriangle /></span>
      <p>{message}</p>
    </div>
  </Modal>
)

export default ConfirmDialog
